import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import {
  LocaleSelector,
  useLanguageLabel,
} from "@redotech/redo-i18n/locale-selector";
import { localizationConfig } from "@redotech/redo-i18n/localization-config";
import { RedoMerchantClientContext } from "@redotech/redo-merchant-app-common/client/context";
import { updateUserLocale } from "@redotech/redo-merchant-app-common/client/user";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { memo, useSyncExternalStore } from "react";

export function useMerchantLocaleSelectorVisible(): boolean {
  return useSyncExternalStore(
    localizationConfig.subscribe,
    localizationConfig.isEnabled,
  );
}

export function useMerchantLanguageLabel(): string {
  return useLanguageLabel();
}

export const MerchantLocaleSelector = memo(function MerchantLocaleSelector({
  onOpenChange,
  open,
}: {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}) {
  const user = useRequiredContext(UserContext);
  const client = useRequiredContext(RedoMerchantClientContext);
  const handleLocaleChange = useHandler((locale: string) => {
    void updateUserLocale(client, { userId: user._id, locale });
  });

  return (
    <LocaleSelector
      onLocaleChange={handleLocaleChange}
      onOpenChange={onOpenChange}
      open={open}
    />
  );
});
